import { useMemo, useState } from "react";

import { useAppStore } from "@store/appStateStore";

import Card from "../Card";

import Indicator from "../metric/Indicator/Indicator";
import BaseSelect from "../control/select/BaseSelect";

import "./OverwiewDashboard.css";
import Container from "../Container";

const OverwiewDashboard: React.FC = () => {
  const { transactions, attendances, directions } = useAppStore();

  const [month, setMonth] = useState<number>(0);

  const totalBalance = useMemo(() => {
    const totalTransactions = transactions.reduce((s, t) => s + t.amount, 0);
    const totalAttendances = attendances.reduce((s, a) => s + a.amount, 0);

    return totalTransactions - totalAttendances;
  }, [attendances, transactions]);

  const totalAttendanceCount = useMemo(() => {
    return attendances.length;
  }, [attendances]);

  const directionStat: Record<
    number,
    {
      dirName: string;
      сontributions: number;
      attendance: number;
      unicParticipant: number;
      practice: number;
    }
  > = useMemo(() => {
    var nds: Record<
      number,
      {
        dirName: string;
        сontributions: number;
        attendance: number;
        unicParticipant: number;
        practice: number;
      }
    > = {};

    directions.forEach((d) => {
      if (!nds?.[d.id]) {
        const dirName = d.name;
        nds[d.id] = {
          сontributions: 0,
          attendance: 0,
          unicParticipant: 0,
          practice: 0,
          dirName: dirName,
        };
      }
      const dirAttendances = attendances.filter((a) => a.direction_id === d.id);

      if (month === 0) {
        nds[d.id].сontributions = dirAttendances.reduce(
          (s, a) => s + a.amount,
          0,
        );
        nds[d.id].attendance = dirAttendances.length;
        nds[d.id].practice = new Set(dirAttendances.map((a) => a.date)).size;
        nds[d.id].unicParticipant = new Set(
          dirAttendances.map((a) => a.participant_id),
        ).size;
        return;
      }

      const fAttendances = dirAttendances.filter((a) => {
        const attendanceDate = new Date(a.date);
        const attendanceMonth = attendanceDate.getMonth() + 1;

        return attendanceMonth === month;
      });

      nds[d.id].сontributions = fAttendances.reduce((s, a) => s + a.amount, 0);
      nds[d.id].attendance = fAttendances.length;
      nds[d.id].practice = new Set(fAttendances.map((a) => a.date)).size;
      nds[d.id].unicParticipant = new Set(
        fAttendances.map((a) => a.participant_id),
      ).size;
    });

    return nds;
  }, [attendances, directions, month]);

  const months = [
    { key: 0, value: "" },
    ...Array.from({ length: 12 }, (_, i) => ({
      key: i + 1,
      value: new Date(2000, i, 1)
        .toLocaleString("ru", { month: "long" })
        .toLowerCase(),
    })),
  ];

  return (
    <Card width="full">
      <Container>
        <Card width="full">
          <div className="dashboard-stats">
            <Indicator
              label={"Общий баланс"}
              value={totalBalance}
              measurement={"р."}
              signed={true}
            />
            <Indicator
              label={"Посещено занятий всего"}
              value={totalAttendanceCount}
            />
          </div>
        </Card>
        <BaseSelect
          id={"month_select"}
          onChange={setMonth}
          value={month}
          options={months}
        />

        {Object.entries(directionStat).map(([_, data]) => {
          return (
            <Card width="half" title={data.dirName}>
              <div className="dashboard-stats">
                <Indicator
                  label={"Взносов"}
                  value={data.сontributions}
                  measurement={"р."}
                />
                <Indicator label={"Занятий"} value={data.practice} />
                <Indicator label={"Посещений"} value={data.attendance} />
                <Indicator
                  label={"Уникальных людей"}
                  value={data.unicParticipant}
                />
              </div>
            </Card>
          );
        })}
      </Container>
    </Card>
  );
};

export default OverwiewDashboard;
